import { __decorate, __metadata } from "tslib";
import ptDialogAutoMounterManager from '@/services/PtDialogAutoMounterManager';
import { injectable } from 'inversify';
const FieldPermissionDialog = () => import('./FieldPermissionDialog.vue');
export { FieldPermissionDialog };
export const FieldPermissionDialogServiceSymbol = Symbol.for('FieldPermissionDialogService');
let FieldPermissionDialogService = class FieldPermissionDialogService {
    constructor() {
        ptDialogAutoMounterManager.register(FieldPermissionDialog);
        this.state = this.getDefState();
    }
    getDefState() {
        return {
            visible: false,
            fieldId: undefined,
        };
    }
    open(fieldId) {
        this.state = {
            ...this.getDefState(),
            visible: true,
            fieldId,
        };
        ptDialogAutoMounterManager.update(FieldPermissionDialog, {
            ...this.state,
            onCloseHandler: this.close.bind(this),
            onSuccessHandler: this.onSuccess.bind(this),
            vIf: true,
        });
    }
    close() {
        this.state = this.getDefState();
        ptDialogAutoMounterManager.toggleOpenState(FieldPermissionDialog, false);
    }
    onSuccess() {
        // 处理成功回调
        this.close();
    }
};
FieldPermissionDialogService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], FieldPermissionDialogService);
export { FieldPermissionDialogService };
